import { useFormik } from "formik";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  createSpecialHolidayService,
  deleteBankAccount,
  deleteSpecialHolidaysService,
  listSpecialHolidaysService,
  productListSelectionService,
  updateProfileService,
  updateSpecialHolidayService,
  updateWeekDaysService,
  ViewBankAccount,
  viewProfileService,
} from "../../../Services/ApiServices";
import Styles from "./ViewProfile.module.css";
import moment from "moment";
import user from "../../../Assets/myprofile/user.svg";
import tag from "../../../Assets/myprofile/tag.svg";
import cash from "../../../Assets/myprofile/cash.svg";
import aadhar from "../../../Assets/myprofile/aadhar.svg";
import card from "../../../Assets/myprofile/card.svg";
import calender from "../../../Assets/myprofile/calender.svg";
import mail from "../../../Assets/myprofile/mail.svg";
import phone from "../../../Assets/myprofile/phone.svg";
import location from "../../../Assets/myprofile/location.svg";
import shop from "../../../Assets/myprofile/shop.svg";
import CITY from "../../../Assets/myprofile/city.svg";
import gender from "../../../Assets/myprofile/gender.svg";
import MyAccountDetails from "../PaymentRequest/MyAccountDetails";
import { Confirmation } from "../../../Modal/Confirmation";
import deleteIcon from "../../../Assets/delete.svg";
import editIcon from "../../../Assets/edit_icon.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Checkbox from "../../CustomCheckBox/CheckBox";
import { useSelector } from "react-redux";

const phoneExp = /^[6,7,8,9]{1}[0-9]{9}$/;

const EMPTY_HOLIDAY_FORM = {
  holiday_id: null,
  from_date: "",
  to_date: "",
  reason: "",
};

// week_day: 0 = Monday, 1 = Tuesday, 2 = Wednesday, 3 = Thursday, 4 = Friday, 5 = Saturday, 6 = Sunday
const WEEK_DAYS = [
  { week_day: 0, label: "Monday" },
  { week_day: 1, label: "Tuesday" },
  { week_day: 2, label: "Wednesday" },
  { week_day: 3, label: "Thursday" },
  { week_day: 4, label: "Friday" },
  { week_day: 5, label: "Saturday" },
  { week_day: 6, label: "Sunday" },
];

const buildWeekDaysData = (weekdaysData) => {
  return WEEK_DAYS.map(({ week_day, label }) => {
    const match = weekdaysData?.find(
      (item) => Number(item.week_day) === week_day
    );
    return {
      week_day,
      label,
      is_open: match ? (match.is_open === 1 ? 1 : 0) : 1,
      open_time: match?.open_time ? match.open_time.slice(0, 5) : "",
      close_time: match?.close_time ? match.close_time.slice(0, 5) : "",
    };
  });
};

export default function ViewProfile() {
  const [isLoader, setIsLoader] = useState(false);
  const [isShowPopup, setIsShowPopup] = useState(false);
  const [bankAccountDetails, setBankAccountDetails] = useState();
  const [productType, setProductType] = useState([2]);
  const DashboardDetails = useSelector((state) => state.dashboard_details);
  const [productVisible, setProductVisible] = useState(false);
  const [weekDaysData, setWeekDaysData] = useState(buildWeekDaysData([]));
  const [appliedFromDay, setAppliedFromDay] = useState(null);
  const [specialHolidays, setSpecialHolidays] = useState([]);
  const [holidayForm, setHolidayForm] = useState(EMPTY_HOLIDAY_FORM);
  const [deleteHolidayId, setDeleteHolidayId] = useState(null);

  const {
    handleChange,
    handleSubmit,
    setValues,
    setFieldValue,
    values,
    errors,
    touched,
  } = useFormik({
    initialValues: {
      username: "",
      email: "",
      mbl: "",
      dob: "",
      alt_mbl: "",
      gender: "",
      address: "",
      city: "",
      state: "",
      pincode: "",
      profile: "",
      pan: "",
      aadhar: "",
      gst: "",
      shipping_name: "",
      shipping_email: "",
      shipping_monile_no: "",
      shipping_city: "",
      shipping_state: "",
      shipping_address: "",
      shipping_pincode: "",
      shop_name: "",
      product_type: [2],
      minimum_order_value: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Required"),
      email: Yup.string().required("Required"),
      mbl: Yup.string()
        .matches(phoneExp, "mobile number must start with 9 or 8 or 7 or 6")
        .required("Required"),
      alt_mbl: Yup.string().matches(
        phoneExp,
        "mobile number must start with 9 or 8 or 7 or 6"
      ),
      // .required("Required"),
      gender: Yup.string().required("Required"),
      address: Yup.string().required("Required"),
      city: Yup.string().required("Required"),
      state: Yup.string().required("Required"),
      pincode: Yup.string()
        // .matches(!PINCODE_REGEX, "Enter valid pincode")
        .required("Required"),
      // profile: Yup.string().required("Required"),
      dob: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      console.log("valuessubmit");

      setIsLoader(true);
      handleUpdate(values);
    },
  });

  useEffect(() => {
    handleViewProfile();
    handleViewBank();
    handleListSpecialHolidays();
  }, []);

  const handleUpdate = (data) => {
    let formData = new FormData();
    formData.append("user_name", data.username);
    formData.append("email", data.email);
    formData.append("gender", parseInt(data.gender));
    formData.append("dob", data.dob);
    formData.append("address", data.address);
    formData.append("alt_mobile", data.alt_mbl);
    formData.append("city", data.city);
    formData.append("state", data.state);
    formData.append("pincode", data.pincode);
    if (typeof data.profile !== "string") {
      formData.append("profile_image", data.profile);
    }
    formData.append("pan_no", data.pan);
    formData.append("aadhaar_no", data.aadhar);
    formData.append("gst_no", data.gst);
    formData.append("minimum_order_value", data.minimum_order_value);

    updateProfileService(formData)
      .then((res) => {
        toast("Profile Updated", { type: "success" });
        setIsLoader(false);
        handleViewProfile();
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => setIsLoader(false));
  };

  const handleProductListSelection = () => {
    let formData = new FormData();
    formData.append("list_type", productType);
    productListSelectionService(formData)
      .then((res) => {
        toast(res?.data?.message, { type: "success" });
        setIsLoader(false);
        handleViewProfile();
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => {
        setProductType("");
        setIsLoader(false);
      });
  };

  const handleWeekDayToggle = (week_day) => {
    setWeekDaysData((prev) =>
      prev.map((day) =>
        day.week_day === week_day
          ? { ...day, is_open: day.is_open ? 0 : 1 }
          : day
      )
    );
  };

  const handleWeekDayTimeChange = (week_day, field, value) => {
    setAppliedFromDay(null);
    setWeekDaysData((prev) =>
      prev.map((day) =>
        day.week_day === week_day ? { ...day, [field]: value } : day
      )
    );
  };

  const handleApplyTimeToAllDaysToggle = (week_day, open_time, close_time, checked) => {
    if (checked) {
      setAppliedFromDay(week_day);
      setWeekDaysData((prev) =>
        prev.map((day) => ({ ...day, open_time, close_time }))
      );
    } else {
      setAppliedFromDay(null);
    }
  };

  const handleSaveWeekDays = () => {
    for (const day of weekDaysData) {
      if (day.is_open && (!day.open_time || !day.close_time)) {
        toast.error(`Please select opening and closing time for ${day.label}`);
        return;
      }
    }

    setIsLoader(true);
    const payload = {
      data: weekDaysData.map((day) => ({
        week_day: day.week_day,
        is_open: day.is_open ? 1 : 2,
        open_time: day.is_open ? `${day.open_time}:00` : null,
        close_time: day.is_open ? `${day.close_time}:00` : null,
      })),
    };

    updateWeekDaysService(payload)
      .then((res) => {
        toast.success(res?.data?.msg || "Opening hours updated");
        handleViewProfile();
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => setIsLoader(false));
  };

  const handleListSpecialHolidays = () => {
    listSpecialHolidaysService()
      .then((res) => {
        setSpecialHolidays(res?.data?.data || []);
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Something went wrong!!");
        }
      });
  };

  const handleHolidayFieldChange = (field, value) => {
    setHolidayForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleEditHoliday = (holiday) => {
    setHolidayForm({
      holiday_id: holiday.id,
      from_date: moment(holiday.from_date, "DD-MM-YY").format("YYYY-MM-DD"),
      to_date: moment(holiday.to_date, "DD-MM-YY").format("YYYY-MM-DD"),
      reason: holiday.reason,
    });
  };

  const handleCancelHolidayEdit = () => {
    setHolidayForm(EMPTY_HOLIDAY_FORM);
  };

  const handleSaveHoliday = () => {
    if (
      !holidayForm.from_date ||
      !holidayForm.to_date ||
      !holidayForm.reason.trim()
    ) {
      toast.error("Please fill from date, to date and reason");
      return;
    }
    if (holidayForm.from_date > holidayForm.to_date) {
      toast.error("From date cannot be after to date");
      return;
    }

    setIsLoader(true);
    const formData = new FormData();
    formData.append("from_date", holidayForm.from_date);
    formData.append("to_date", holidayForm.to_date);
    formData.append("reason", holidayForm.reason);

    const isEditing = !!holidayForm.holiday_id;
    if (isEditing) {
      formData.append("holiday_id", holidayForm.holiday_id);
    }

    const apiCall = isEditing
      ? updateSpecialHolidayService(formData)
      : createSpecialHolidayService(formData);

    apiCall
      .then((res) => {
        toast.success(
          res?.data?.msg ||
            `Special holiday ${isEditing ? "updated" : "created"} successfully`
        );
        setHolidayForm(EMPTY_HOLIDAY_FORM);
        handleListSpecialHolidays();
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => setIsLoader(false));
  };

  const handleDeleteHoliday = () => {
    setIsLoader(true);
    const formData = new FormData();
    formData.append("holiday_id", deleteHolidayId);

    deleteSpecialHolidaysService(formData)
      .then((res) => {
        toast.success(res?.data?.msg || "Special holiday deleted successfully");
        setDeleteHolidayId(null);
        handleListSpecialHolidays();
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => setIsLoader(false));
  };

  const handleViewBank = () => {
    setIsLoader(true);
    ViewBankAccount()
      .then((res) => {
        if (res.data.status === 1) {
          setBankAccountDetails(res.data.data);
        } else {
          // toast.error(res.data.msg);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => {
        setIsLoader(false);
      });
  };
  const handleViewProfile = () => {
    setIsLoader(true);
    viewProfileService()
      .then(({ data }) => {
        console.log(data, "prifiledata");

        setValues({
          ...values,
          username: data.user_name,
          email: data.email,
          mbl: data.mobile_no,
          alt_mbl: data.alternative_mobile_no,
          gender: data.gender.toString(),
          address: data.address,
          city: data.city,
          state: data.state,
          pincode: data.pincode,
          profile: data.profile_img,
          pan: data.pan_no,
          aadhar: data.aadhaar_no,
          gst: data.gst_no,
          dob:
            data.dob !== ""
              ? moment(data.dob, "DD-MM-YYYY").format("YYYY-MM-DD")
              : moment().format("YYYY-MM-DD"),
          shipping_address: data.shipping_address,
          shipping_city: data.shipping_city_name,
          shipping_email: data.shipping_email,
          shipping_monile_no: data.shipping_monile_no,
          shipping_name: data.shipping_name,
          shipping_pincode: data.shipping_pincode,
          shipping_state: data.shipping_state_name,
          shop_name: data.shop_name,
          product_type: [...data?.product_list],
          minimum_order_value: data?.minimum_order_value,
        });
        setProductVisible({
          franchise: data?.franchise,
          kstore: data?.kstore,
        });
        setProductType(data?.product_list);
        setWeekDaysData(buildWeekDaysData(data?.weekdays_data));
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => setIsLoader(false));
  };

  console.log(errors, "errors", values);

  const handleDeletebank = () => {
    setIsLoader(true);
    let formData = new FormData();
    formData.append("bank_account_id", bankAccountDetails?.account_id);
    deleteBankAccount(formData)
      .then((res) => {
        if (res.data.status === 1) {
          toast.success(res.data.msg);
          setBankAccountDetails();
          handleViewBank();
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => {
        setIsLoader(false);
      });
  };
  console.log(values, "forlvalues");

  // const handleSaveMinimumOrderValue = () => {
  //   setIsLoader(true);
  //   let formData = new formData();
  //   formData.append("minimum_order_value", values.minimum_order_value);

  //   UpdateMinimumOrderValue(formData)
  //     .then((res) => {
  //       toast.success(res?.data?.message);
  //     })
  //     .catch((err) => {
  //       if (err?.response?.data?.detail) {
  //         toast.error(err.response.data.detail[0].msg);
  //       } else {
  //         toast.error("Something went wrong!!");
  //       }
  //     })
  //     .finally(() => {
  //       setIsLoader(false);
  //     });
  // };

  const getGender = (value) => {
    switch (value) {
      case 1:
        return "Male";
      case 2:
        return "Female";

      default:
        return "";
    }
  };

  const handleViewBankdetails = (data) => {
    handleViewBank();
  };

  return (
    <div className={Styles.overallContainer + " container-fluid p-0"}>
      {isLoader ? (
        <div className={Styles.loaderParent}>
          <div className={Styles.loader}></div>
        </div>
      ) : null}
      {isShowPopup ? (
        <MyAccountDetails
          isOpen={isShowPopup}
          handleTableData={handleViewBank}
          onHide={() => setIsShowPopup(false)}
          bankAccountDetails={bankAccountDetails}
        />
      ) : null}
      {deleteHolidayId ? (
        <Confirmation
          isOpen={!!deleteHolidayId}
          onHide={() => setDeleteHolidayId(null)}
          onSucess={handleDeleteHoliday}
          title="Delete Special Holiday"
          content="Are you sure you want to delete this special holiday?"
          isConfirmation={true}
          successBtn="Delete"
        />
      ) : null}
      <form onSubmit={(e) => e.preventDefault()}>
        <div className={Styles.pageWrap}>
          <p className="fontBold pt-3 pb-1 fs-4">
            My <span className="orange">Profile</span>
          </p>
          <div className={Styles.whiteBg}>
            <div className={Styles.cards}>
              <p className={Styles.accText + " label"}>Personal Details</p>
              <div className="row">
                <div className="col-lg-4  col-md-6 col-12 mb-3">
                  <div className="d-flex">
                    <div className={Styles.profileIcon}>
                      <img src={user}></img>
                    </div>
                    <div>
                      <label className="label">Concern Name:</label>
                      <p className={Styles.profileText}>{values.username}</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4  col-md-6 col-12 mb-3">
                  <div className="d-flex">
                    <div className={Styles.profileIcon}>
                      <img src={mail}></img>
                    </div>
                    <div>
                      <label className="label">Email:</label>
                      <p className={Styles.profileText}>{values.email}</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4  col-md-6 col-12 mb-3">
                  <div className="d-flex">
                    <div className={Styles.profileIcon}>
                      <img src={phone}></img>
                    </div>
                    <div>
                      <label className="label">Mobile Number:</label>
                      <p className={Styles.profileText}>{values.mbl}</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4  col-md-6 col-12 mb-3">
                  <div className="d-flex">
                    <div className={Styles.profileIcon}>
                      <img src={phone}></img>
                    </div>
                    <div>
                      <label className="label">Alt Mobile:</label>
                      <p className={Styles.profileText}>{values.alt_mbl}</p>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4  col-md-6 col-12 mb-3">
                  <div className="d-flex">
                    <div className={Styles.profileIcon}>
                      <img src={calender}></img>
                    </div>
                    <div>
                      <label className="label">DOB:</label>
                      <p className={Styles.profileText}>{values.dob}</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4  col-md-6 col-12 mb-3">
                  <div className="d-flex">
                    <div className={Styles.profileIcon}>
                      <img src={tag}></img>
                    </div>
                    <div>
                      <label className="label">State:</label>
                      <p className={Styles.profileText}>{values.state}</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4  col-md-6 col-12 mb-3">
                  <div className="d-flex">
                    <div className={Styles.profileIcon}>
                      <img src={CITY}></img>
                    </div>
                    <div>
                      <label className="label">City:</label>
                      <p className={Styles.profileText}>{values.city}</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4  col-md-6 col-12 mb-3">
                  <div className="d-flex">
                    <div className={Styles.profileIcon}>
                      <img src={cash}></img>
                    </div>
                    <div>
                      <label className="label">Pincode :</label>
                      <p className={Styles.profileText}>{values.pincode}</p>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4  col-md-6 col-12 mb-3">
                  <div className="d-flex">
                    <div className={Styles.profileIcon}>
                      <img src={gender}></img>
                    </div>
                    <div>
                      <label className="label">Gender:</label>
                      <p className={Styles.profileText}>
                        {getGender(parseInt(values.gender))}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4  col-md-6 col-12 mb-3">
                  <div className="d-flex">
                    <div className={Styles.profileIcon}>
                      <img src={location}></img>
                    </div>
                    <div>
                      <label className="label">Address:</label>
                      <p className={Styles.profileText}>{values.address}</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4  col-md-6 col-12 mb-3">
                  <div className="d-flex">
                    <div className={Styles.profileIcon}>
                      <img src={shop}></img>
                    </div>
                    <div>
                      <label className="label">Shop Name:</label>
                      <p className={Styles.profileText}>{values.shop_name}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={Styles.cards}>
              <div className={Styles.accParentContainer}>
                <p className={Styles.accText + " label"}>Shipping Details</p>
                <div className="row">
                  <div className="col-lg-4  col-md-6 col-12 mb-3">
                    <div className="d-flex">
                      <div className={Styles.profileIcon}>
                        <img src={tag}></img>
                      </div>
                      <div>
                        <label className="label">Shipping Name:</label>
                        <p className={Styles.profileText}>
                          {values.shipping_name}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4  col-md-6 col-12 mb-3">
                    <div className="d-flex">
                      <div className={Styles.profileIcon}>
                        <img src={mail}></img>
                      </div>
                      <div>
                        <label className="label">Shipping Email:</label>
                        <p className={Styles.profileText}>
                          {values.shipping_email}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4  col-md-6 col-12 mb-3">
                    <div className="d-flex">
                      <div className={Styles.profileIcon}>
                        <img src={phone}></img>
                      </div>
                      <div>
                        <label className="label">Shipping Mobile Number:</label>
                        <p className={Styles.profileText}>
                          {values.shipping_monile_no}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4  col-md-6 col-12 mb-3">
                    <div className="d-flex">
                      <div className={Styles.profileIcon}>
                        <img src={location}></img>
                      </div>
                      <div>
                        <label className="label">Shipping Address:</label>
                        <p className={Styles.profileText}>
                          {values.shipping_address}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4  col-md-6 col-12 mb-3">
                    <div className="d-flex">
                      <div className={Styles.profileIcon}>
                        <img src={cash}></img>
                      </div>
                      <div>
                        <label className="label">Shipping State:</label>
                        <p className={Styles.profileText}>
                          {values.shipping_state}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4  col-md-6 col-12 mb-3">
                    <div className="d-flex">
                      <div className={Styles.profileIcon}>
                        <img src={tag}></img>
                      </div>
                      <div>
                        <label className="label">Shipping City:</label>
                        <p className={Styles.profileText}>
                          {values.shipping_city}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4  col-md-6 col-12 mb-3">
                    <div className="d-flex">
                      <div className={Styles.profileIcon}>
                        <img src={tag}></img>
                      </div>
                      <div>
                        <label className="label">Shipping Pincode :</label>
                        <p className={Styles.profileText}>
                          {values.shipping_pincode}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={Styles.cards}>
              <div className={Styles.accParentContainer}>
                <div className={Styles.BankAccountOuter}>
                  <p className={Styles.accText + " label"}>
                    My Bank Account Details
                  </p>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <button
                      className={Styles.addbankDetails}
                      onClick={() => setIsShowPopup(true)}
                    >
                      {bankAccountDetails ? "Edit" : "Add"}
                    </button>
                    {bankAccountDetails ? (
                      <button
                        className={Styles.Deletebtn}
                        onClick={() => handleDeletebank()}
                      >
                        Delete
                      </button>
                    ) : // <OverlayTrigger
                    //   placement="bottom"
                    //   overlay={<Tooltip>Delete</Tooltip>}
                    // >
                    //   <img
                    //     style={{ width: "25px", height: "25px" }}
                    //     onClick={() => {
                    //       handleDeletebank();
                    //       // setViewId(e?.customer_wishlist_id);
                    //       // setIsWishListView(true);
                    //     }}
                    //     className={Styles.del}
                    //     src={deleteIcon}
                    //     alt="view"
                    //   />
                    // </OverlayTrigger>
                    null}
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4  col-md-6 col-12 mb-3">
                    <div className="d-flex">
                      <div className={Styles.profileIcon}>
                        <img src={card}></img>
                      </div>
                      <div>
                        <label className="label">Bank Name:</label>
                        <p className={Styles.profileText}>
                          {bankAccountDetails?.bank_name}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4  col-md-6 col-12 mb-3">
                    <div className="d-flex">
                      <div className={Styles.profileIcon}>
                        <img src={aadhar}></img>
                      </div>
                      <div>
                        <label className="label">Account Name:</label>
                        <p className={Styles.profileText}>
                          {bankAccountDetails?.account_name}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4  col-md-6 col-12 mb-3">
                    <div className="d-flex">
                      <div className={Styles.profileIcon}>
                        <img src={tag}></img>
                      </div>
                      <div>
                        <label className="label">Branch Name:</label>
                        <p className={Styles.profileText}>
                          {bankAccountDetails?.branch_name}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4  col-md-6 col-12 mb-3">
                    <div className="d-flex">
                      <div className={Styles.profileIcon}>
                        <img src={tag}></img>
                      </div>
                      <div>
                        <label className="label">Account Number:</label>
                        <p className={Styles.profileText}>
                          {bankAccountDetails?.account_no}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4  col-md-6 col-12 mb-3">
                    <div className="d-flex">
                      <div className={Styles.profileIcon}>
                        <img src={tag}></img>
                      </div>
                      <div>
                        <label className="label">IFSC Number:</label>
                        <p className={Styles.profileText}>
                          {bankAccountDetails?.ifsc_code}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={Styles.btnContainer}></div>
              </div>
            </div>
            <div className={Styles.cards}>
              <div className={Styles.accParentContainer}>
                <p className={Styles.accText + " label"}>Account Details</p>
                <div className="row">
                  <div className="col-lg-4  col-md-6 col-12 mb-3">
                    <div className="d-flex">
                      <div className={Styles.profileIcon}>
                        <img src={card}></img>
                      </div>
                      <div>
                        <label className="label">PAN No:</label>
                        <p className={Styles.profileText}>{values.pan}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4  col-md-6 col-12 mb-3">
                    <div className="d-flex">
                      <div className={Styles.profileIcon}>
                        <img src={aadhar}></img>
                      </div>
                      <div>
                        <label className="label">Aadhaar No:</label>
                        <p className={Styles.profileText}>{values.aadhar}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4  col-md-6 col-12 mb-3">
                    <div className="d-flex">
                      <div className={Styles.profileIcon}>
                        <img src={tag}></img>
                      </div>
                      <div>
                        <label className="label">GST No:</label>
                        <p className={Styles.profileText}>{values.gst}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={Styles.btnContainer}></div>
              </div>
            </div>

            {DashboardDetails?.subscription_status === 1 &&
            productVisible?.franchise == 1 &&
            productVisible?.kstore == 1 ? (
              <div
                className={Styles.cards}
                id="productTypeCard"
                style={{ overflow: "hidden" }}
              >
                <div
                  className={Styles.accParentContainer}
                  style={{ overflow: "hidden" }}
                >
                  <p className={Styles.accText + " label"}>
                    Product Visibility
                  </p>
                  <div className="row">
                    <Checkbox
                      handleCallApi={(value) => {
                        if (productType.includes(value)) {
                          let typeofproduct = productType.filter(
                            (item) => item !== value
                          );
                          setProductType(typeofproduct);
                        } else {
                          setProductType([...productType, value]);
                        }
                      }}
                      checkboxData={[
                        {
                          show: productVisible?.franchise == 1 ? false : true,
                          product_list_id: 1,
                          product_list_name: "Inventory Product",
                        },
                        {
                          show: productVisible?.kstore == 1 ? false : true,
                          product_list_id: 2,
                          product_list_name: "KSTORe Product",
                        },
                      ]}
                      filterData={
                        productType ? productType : values?.product_type
                      }
                      Id={"product_list_id"}
                      Name={"product_list_name"}
                      disabled={
                        productVisible?.franchise == 1 &&
                        productVisible?.kstore == 1
                          ? false
                          : true
                      }
                    />
                  </div>
                  <div style={{ marginTop: 20 }}>
                    <button
                      className={Styles.addbankDetails}
                      onClick={() => handleProductListSelection()}
                    >
                      Save
                    </button>
                  </div>

                  <div className={Styles.btnContainer}></div>
                </div>
              </div>
            ) : null}

            <div className={Styles.cards} id="productTypeCard">
              <div className={Styles.accParentContainer}>
                <p className={Styles.accText + " label"}>Order Value</p>
                <div className="row">
                  <div className={Styles.categories + " col-md-3 col-sm-12"}>
                    <label className="label">Minimum Order Value</label>
                    <input
                      type="text"
                      placeholder="Minimum Order Value"
                      className={Styles.filterInput + " contentFont"}
                      value={values.minimum_order_value}
                      onChange={(e) =>
                        setFieldValue("minimum_order_value", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div style={{ marginTop: 20 }}>
                  <button
                    className={Styles.addbankDetails}
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
                <div className={Styles.btnContainer}></div>
              </div>
            </div>

            <div className={Styles.cards} id="weekDaysCard">
              <div className={Styles.accParentContainer}>
                <p className={Styles.accText + " label"}>
                  Shop Opening Hours
                </p>

                {weekDaysData.map((day) => (
                  <div key={day.week_day} className={Styles.weekDayRow}>
                    <span className={Styles.weekDayLabel}>{day.label}</span>
                    <div
                      className={`form-check form-switch mb-0 ${Styles.weekDaySwitchWrapper}`}
                    >
                      <input
                        className={`form-check-input ${Styles.weekDaySwitch}`}
                        type="checkbox"
                        role="switch"
                        checked={!!day.is_open}
                        onChange={() => handleWeekDayToggle(day.week_day)}
                      />
                    </div>
                    {day.is_open ? (
                      <div className={Styles.weekDayTimes}>
                        <div className={Styles.weekDayTimeField}>
                          <label>Open Time</label>
                          <input
                            type="time"
                            className={Styles.weekDayTimeInput}
                            value={day.open_time}
                            onChange={(e) =>
                              handleWeekDayTimeChange(
                                day.week_day,
                                "open_time",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className={Styles.weekDayTimeField}>
                          <label>Close Time</label>
                          <input
                            type="time"
                            className={Styles.weekDayTimeInput}
                            value={day.close_time}
                            onChange={(e) =>
                              handleWeekDayTimeChange(
                                day.week_day,
                                "close_time",
                                e.target.value
                              )
                            }
                          />
                        </div>
                        {day.open_time && day.close_time && (
                          <div className={Styles.weekDayApplyAllField}>
                            <label className={Styles.weekDayApplyAllSpacer}>
                              &nbsp;
                            </label>
                            <label
                              className={Styles.weekDayApplyAllLabel}
                              title="Apply this time to all days"
                            >
                              <input
                                type="checkbox"
                                checked={appliedFromDay === day.week_day}
                                onChange={(e) =>
                                  handleApplyTimeToAllDaysToggle(
                                    day.week_day,
                                    day.open_time,
                                    day.close_time,
                                    e.target.checked
                                  )
                                }
                              />
                              Apply to all
                            </label>
                          </div>
                        )}
                      </div>
                    ) : (
                      <span className={Styles.weekDayClosedText}>Closed</span>
                    )}
                  </div>
                ))}
                <div style={{ marginTop: 20 }}>
                  <button
                    className={Styles.addbankDetails}
                    onClick={handleSaveWeekDays}
                  >
                    Save
                  </button>
                </div>
                <div className={Styles.btnContainer}></div>
              </div>
            </div>

            <div className={Styles.cards} id="specialHolidaysCard">
              <div className={Styles.accParentContainer}>
                <p className={Styles.accText + " label"}>Special Holidays</p>

                <div className={Styles.holidayFormRow}>
                  <div className={Styles.holidayFormField}>
                    <label className="label">From Date</label>
                    <input
                      type="date"
                      className={Styles.filterInput + " contentFont"}
                      value={holidayForm.from_date}
                      onChange={(e) =>
                        handleHolidayFieldChange("from_date", e.target.value)
                      }
                    />
                  </div>
                  <div className={Styles.holidayFormField}>
                    <label className="label">To Date</label>
                    <input
                      type="date"
                      className={Styles.filterInput + " contentFont"}
                      value={holidayForm.to_date}
                      onChange={(e) =>
                        handleHolidayFieldChange("to_date", e.target.value)
                      }
                    />
                  </div>
                  <div
                    className={`${Styles.holidayFormField} ${Styles.holidayFormFieldReason}`}
                  >
                    <label className="label">Reason</label>
                    <input
                      type="text"
                      placeholder="Reason"
                      className={Styles.filterInput + " contentFont"}
                      value={holidayForm.reason}
                      onChange={(e) =>
                        handleHolidayFieldChange("reason", e.target.value)
                      }
                    />
                  </div>
                </div>

                <div className={Styles.holidayActions}>
                  <button
                    className={Styles.addbankDetails}
                    onClick={handleSaveHoliday}
                  >
                    {holidayForm.holiday_id ? "Update Holiday" : "Add Holiday"}
                  </button>
                  {holidayForm.holiday_id ? (
                    <button
                      className={Styles.Deletebtn}
                      onClick={handleCancelHolidayEdit}
                    >
                      Cancel
                    </button>
                  ) : null}
                </div>

                {specialHolidays.length > 0 && (
                  <div className={Styles.holidayList}>
                    {specialHolidays.map((holiday) => {
                      const isEditingThis =
                        holidayForm.holiday_id === holiday.id;
                      return (
                        <div
                          key={holiday.id}
                          className={`${Styles.holidayRow} ${
                            isEditingThis ? Styles.holidayRowEditing : ""
                          }`}
                        >
                          <div className={Styles.holidayInfo}>
                            <span className={Styles.holidayDates}>
                              {holiday.from_date} - {holiday.to_date}
                            </span>
                            <span className={Styles.holidayReason}>
                              {holiday.reason}
                            </span>
                          </div>
                          {isEditingThis ? (
                            <span className={Styles.holidayEditingBadge}>
                              Editing
                            </span>
                          ) : (
                            <div className={Styles.holidayActionsIcons}>
                              <OverlayTrigger
                                placement="bottom"
                                overlay={<Tooltip>Edit</Tooltip>}
                              >
                                <img
                                  className={Styles.actionsIcon}
                                  src={editIcon}
                                  onClick={() => handleEditHoliday(holiday)}
                                  alt="edit"
                                />
                              </OverlayTrigger>
                              <OverlayTrigger
                                placement="bottom"
                                overlay={<Tooltip>Delete</Tooltip>}
                              >
                                <img
                                  className={Styles.actionsIcon}
                                  src={deleteIcon}
                                  onClick={() =>
                                    setDeleteHolidayId(holiday.id)
                                  }
                                  alt="delete"
                                />
                              </OverlayTrigger>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}

                <div className={Styles.btnContainer}></div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
